import type { PathButtonProps } from "shared/react";
import type { HashTagData } from "shared/util/tag";
import { ValueError, getSlug } from "shelving";
import { getStringStyle } from "shared/util/style";

export function HashTagButton({ slug: messySlug, path, mods = "", disabled = false }: HashTagData & PathButtonProps): React.ReactElement {
	const slug = getSlug(messySlug);
	if (!slug) throw new ValueError("Invalid hash tag", messySlug);
	return (
		<a className={`button ${mods}`} href={disabled ? undefined : path ?? `/tag/${slug}`} style={getStringStyle("/img/hash.angled.svg", slug)}>
			<span>{`#${slug}`}</span>
		</a>
	);
}
